<h2 mat-dialog-title class="bold-header">Import PriceList Excel Preview</h2>
@if (isValidating) {
  <div class="validation-overlay d-flex flex-column justify-content-center align-items-center">
    <div class="spinner-border text-primary" role="status" style="width: 3rem; height: 3rem;">
      <span class="visually-hidden"></span>
    </div>
    <p class="mt-3 fs-5 text-primary">Validating data, please wait...</p>
  </div>
}
@if (isSaving) {
  <div class="validation-overlay d-flex flex-column justify-content-center align-items-center">
    <div class="spinner-border text-primary" role="status" style="width: 3rem; height: 3rem;">
      <span class="visually-hidden"></span>
    </div>
    <p class="mt-3 fs-5 text-primary">Saving Price List data, please wait...</p>
  </div>
}
<div class="mat-table-container position-relative">

  <table mat-table [dataSource]="validatedData" class="mat-elevation-z8">

    <!-- Dynamic Column Definitions -->
    @for (header of previewHeaders; track header) {
      <ng-container [matColumnDef]="header">
        <th mat-header-cell *matHeaderCellDef class="bold-header">{{ header }}</th>
        <td mat-cell *matCellDef="let row">
          <!-- Date Formatting -->
          @if (dateHeaders.includes(header) && isValidDate(row[header])) {
            {{ row[header] | date: 'yyyy-MM-dd' }}
          }
          @if (!dateHeaders.includes(header)) {
            @if (header === 'ValidationStatus') {
              <div>
                <div class="d-flex flex-column gap-3">
                  @if (row[header]?.length > 0) {
                    @for (err of row[header]; track err; let i = $index) {
                      <div
                        class="text-danger d-flex align-items-start gap-3 text-wrap">
                        <span>{{ i + 1 }}.</span>
                        <span>{{ err }}</span>
                      </div>
                    }
                  } @else {
                    <div class="text-success">✅ No errors for this condition.</div>
                  }
                </div>
              </div>
            }
            @if (header !== 'ValidationStatus') {
              <p>
                {{ row[header] }}
              </p>
            }
          }
        </td>
      </ng-container>
    }

    <tr mat-header-row *matHeaderRowDef="previewHeaders"></tr>
    <tr mat-row *matRowDef="let row; columns: previewHeaders;"></tr>
  </table>

  <div class="action-buttons">
    <button mat-raised-button class="green-button" (click)="save()" [disabled]="!isSaveEnabled">Save</button>
    <button mat-raised-button color="primary" (click)="validate()" [disabled]="!hasNoErrors()">
      @if (isValidating) {
        <mat-spinner></mat-spinner>
      }
      @if (isValidating) {
        <span>Validating...</span>
      }
      @if (!isValidating) {
        <span>Validate</span>
      }
    </button>
    <button mat-raised-button color="warn" (click)="closeModel()">Close</button>
  </div>
</div>